import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import logger from "utils/logger";
import { useHistory, useLocation } from "react-router-dom";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import useLoginInfo from "hooks/useLoginInfo";
import { REGEX_VALUES } from 'utils/regexValues';
import Maybe from 'components/__new/common/Maybe';
import GetStartedPersonalInfo from 'components/__new/auth/signup/GetStartedPersonalInfo';
import GetStartedBusinessDetails from 'components/__new/auth/signup/GetStartedBusinessDetails';
import GetStartedCreatePassword from 'components/__new/auth/signup/GetStartedCreatePassword';
import { clearSignupInfo, requestNewUserOtp, saveNewUserdetails } from 'store/auth/user/action';


export const GetStarted = () => {
    const history = useHistory();
    const location = useLocation();
    const {isLogin, userInfo} = useLoginInfo();
    const [formErrors, setFormErrors] = useState({
        firstName: null,
        lastName: null,
        email: null,
        phoneNumber: null,
        businessName: null,
        customRole: null,
        password_confirmation: null,
    });
    const [formStep, setFormStep] = useState(1)
    const dispatch = useDispatch();
    const { newUserOtpData, newUserOtpLoading } = useSelector((s) => s.auth.user);
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        businessName: "",
        businessType: "",
        roleInCompany: "",
        customRole: "",
        country: "",
        state: "",
        password: "",
        password_confirmation: "",
    })

    const decrementStep = () => setFormStep((prev) => prev - 1)
    
    const onSubmitPersonalInfo = async (e) => {
        e.preventDefault();
        setFormStep(2);
    }

    const onSubmitBusinessDetails = async (e) => {
        e.preventDefault();
        dispatch(saveNewUserdetails(form));
        dispatch(requestNewUserOtp({
            email: form.email,
            companyName: form.businessName,
        }));
        // setFormStep(3);
    }

    const onSubmitPwdCreation = async (e) => {
        e.preventDefault();
        dispatch(saveNewUserdetails(form));
        dispatch(requestNewUserOtp({
            email: form.email,
            companyName: form.businessName,
        }));
    }
    
    const updateForm = (e, fieldName, regexFn, errorText) => {
        const fieldValue = e.target.value
        
        if(fieldName === "email") {
            if(!REGEX_VALUES.EMAIL.test(fieldValue)) {
                setFormErrors({
                    ...formErrors,
                    email: "Invalid email",
                })
            } else {
                setFormErrors({
                    ...formErrors,
                    email: null,
                })
            }
        } else if(fieldName === "businessName") {
            if(fieldValue && fieldValue?.length < 3) {
                setFormErrors({
                    ...formErrors,
                    businessName: "Business Name must be at least 3 characters",
                })
            } else {
                setFormErrors({
                    ...formErrors,
                    businessName: null,
                })
            }
        } else if(fieldName === "password_confirmation") {
            if(fieldValue && fieldValue !== form?.password) {
                setFormErrors({
                    ...formErrors,
                    password_confirmation: "Passwords do not match",
                })
            } else {
                setFormErrors({
                    ...formErrors,
                    password_confirmation: null,
                })
            }
        } else {
            if(regexFn.test(fieldValue) || (fieldName !== "businessName" && fieldValue?.includes(" "))) {
                setFormErrors({
                    ...formErrors,
                    [fieldName]: errorText || "Invalid input",
                })
            } else {
                setFormErrors({
                    ...formErrors,
                    [fieldName]: null,
                })
            }
        }
        setForm({
            ...form,
            [fieldName]: fieldValue
        })
    }

    useEffect(() => {
        if (isLogin === true){
            logger("employer-sign-in", userInfo);
            history.push("/dashboard");
        }
        // eslint-disable-next-line
    }, [isLogin])

    useEffect(() => {
        dispatch(clearSignupInfo());
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (newUserOtpData?.message === "OTP successfully sent" && location.pathname !== "/verify-email"){
            history.push("/onboarding/verify-email");
        }
        // eslint-disable-next-line
    }, [newUserOtpData])

    return (
        <>

            <DynamicHeadTag
                headerText="Login"
            />

            <div className="p-8">
                    
                    <Maybe condition={formStep === 1}>
                        <GetStartedPersonalInfo 
                            form={form}
                            formErrors={formErrors}
                            updateForm={updateForm}
                            submitForm={onSubmitPersonalInfo} 
                        />
                    </Maybe>
                    
                    <Maybe condition={formStep === 2}>
                        <GetStartedBusinessDetails 
                            form={form}
                            setForm={setForm}
                            formErrors={formErrors}
                            updateForm={updateForm}
                            submitForm={onSubmitBusinessDetails} 
                            decrementStep={decrementStep}
                            loading={newUserOtpLoading}
                        />
                    </Maybe>
                    
                    <Maybe condition={formStep === 3}>
                        <GetStartedCreatePassword 
                            form={form}
                            setForm={setForm}
                            updateForm={updateForm}
                            formErrors={formErrors}
                            submitForm={onSubmitPwdCreation} 
                            decrementStep={decrementStep}
                            loading={newUserOtpLoading}
                        />
                    </Maybe>
            </div>
        </>
    )
}


export default GetStarted;